export const navigationItems = [
  {
    name: 'navbarItems.dashboard',
    route: '/',
    icon: 'dashboard_inactive',
    iconActive: 'dashboard_active'
  },
  {
    name: 'navbarItems.buySell',
    route: '/buy-sell',
    icon: 'buysell_inactive',
    iconActive: 'buysell_active'
  },
  {
    name: 'navbarItems.exchanges',
    route: '/exchange',
    icon: 'exchange_inactive',
    iconActive: 'exchange_active'
  },
  {
    name: 'navbarItems.settings',
    route: '/settings',
    icon: 'settings_inactive',
    iconActive: 'settings_active'
  },
  {
    name: 'navbarItems.inbox',
    route: '/inbox',
    icon: 'inbox_inactive',
    iconActive: 'inbox_active'
  },
  {
    name: 'navbarItems.loans',
    route: '/loans',
    icon: 'loans_bag_inactive',
    iconActive: 'loans_bag_active'
  }
];
